module.exports = __webpack_public_path__ + "Averta-Black.9b957c72fb52ab8507e9.woff";


//////////////////
// WEBPACK FOOTER
// /Users/nolanclark/Desktop/Development/GoPark/src/fonts/Averta-Black.woff
// module id = ../../../../../src/fonts/Averta-Black.woff
// module chunks = styles